import { defineProvider } from '@nuxt/image/runtime'
import { getSignificantObject } from '@repo/alt/common/Utils/Data.ts'

export default defineProvider({
  getImage: (src, { modifiers }) => {
    const config = useRuntimeConfig()
    const appConfig = useAppConfig()
    const apiUrl = import.meta.server
      ? config.API_BASE_URL || config.public.API_BASE_URL
      : config.public.API_BASE_URL
    const resourceId = src

    const request = {
      Width: modifiers.width,
      Height: modifiers.height,
      Mode: 'Stretch',
    }

    const query = new URLSearchParams(
      Object.entries(getSignificantObject(request)),
    )

    const url = new URL(
      `/showcases/v1/${appConfig.host}/resources/file${resourceId}`,
      apiUrl,
    )
    url.search = query.toString()

    return {
      url: url.toString(),
    }
  },
})
